// extracted by mini-css-extract-plugin
export var menuIcon = "_tr-0";
export var menuIconInline = "_tr-1";